interface SeoProps {
  title: string;
  description?: string;
  image?: string;
  type?: 'website' | 'article';
  noIndex?: boolean;
  jsonLd?: Record<string, unknown>;
}

const SITE_NAME = 'Care For Him';
const DEFAULT_DESCRIPTION =
  "A men's mental health initiative offering support, resources, events and community.";

/**
 * Per-route meta / OpenGraph / JSON-LD.
 * Uses React 19's native metadata hoisting — <title>/<meta>/<link> rendered here
 * are automatically hoisted into <head>. No external helmet library needed.
 */
export function Seo({ title, description, image, type = 'website', noIndex, jsonLd }: SeoProps) {
  const fullTitle = title === SITE_NAME ? title : `${title} — ${SITE_NAME}`;
  const desc = description ?? DEFAULT_DESCRIPTION;

  return (
    <>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      {noIndex && <meta name="robots" content="noindex,nofollow" />}
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:type" content={type} />
      {image && <meta property="og:image" content={image} />}
      <meta name="twitter:card" content={image ? 'summary_large_image' : 'summary'} />
      {jsonLd && (
        // eslint-disable-next-line react/no-danger
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />
      )}
    </>
  );
}
